import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const EmailTemplateService = {
  getList: async () => {
    const response = await apiService.get("/emailtemplates");
    return response.data;
  },
 
  create: async (data) => {
    const response = await apiService.post("/emailtemplates", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    const response = await apiService.put(
      `/emailtemplates/${id}`,
      updatedData,
    );
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/emailtemplates/${id}`);

    return response.data;
  },
  delete: async (id) => {
   
    const response = await apiService.delete(`/emailtemplates/${id}`);
    return response.data;
  },
 
};
export default EmailTemplateService;
